import { ItemMetadata } from "../item/item-metadata.model"
import { Metadata } from "../metadata.model"


export abstract class LayoutMetadataBase implements Metadata {

    id: string
    type: string = "none"

    constructor(type: string) {
        this.id = "layoutId" + Math.floor(Math.random() * 1000000)
        this.type = type
    }

    abstract from(layout: LayoutMetadata): void

}

export interface LayoutMetadata extends LayoutMetadataBase { }